import store from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Called when we select discard, resets the appearance options in store
 */
export default mutatorAction('discardAppearanceOption', function() {
    let optionState = store();
    optionState.weekStartDay = null;
    optionState.timeIncrement = null;
    optionState.workDays = null;
    optionState.showWeekNumbers = null;
    optionState.firstWeekOfYear = null;
    optionState.workingHoursStartTime = null;
    optionState.workingHoursEndTime = null;
    optionState.workingHoursTimeZoneId = null;
});
